import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '~src/hooks/api/constants';
import { UseQueryLocalOptions } from '~src/config/queryClient';
import { getAdminFeedbackCycle } from './requests';
import { AdminFeedbackCycle } from './types';

const useAdminFeedbackCycle = (id: string, options?: UseQueryLocalOptions<AdminFeedbackCycle>) =>
  useQuery({
    queryKey: [QUERY_KEYS.ADMIN_FEEDBACK_CYCLE, id],
    queryFn: () => getAdminFeedbackCycle(id),
    enabled: !!id,
    ...options,
  });

export default useAdminFeedbackCycle;
